import { createReducer } from '@common/redux-utils';

import {
  ZeroVendorActionType,
  SearchZeroVendorListStartAction,
  SearchZeroVendorListSuccessAction,
  SearchZeroVendorListFailureAction
} from './zero-vendor.actions';

import { ServiceWorkOrderSearchViewModel } from '@models/ServiceWorkOrder';

export interface ZeroVendorState {
  readonly swoList: Array<ServiceWorkOrderSearchViewModel>;
  readonly query: string | null;
  readonly pageNumber: number;
  readonly pageSize: number;
  readonly pageCount: number;
  readonly orderBy: string;
  readonly message: string;
  readonly loading?: boolean;
}

export const initialZeroVendorState: ZeroVendorState = {
  swoList: [] as Array<ServiceWorkOrderSearchViewModel>,
  query: '',
  pageNumber: 0,
  pageSize: 10,
  pageCount: 10,
  orderBy: '',
  message: ''
};

/***** Search Dispatch List ****/
function handleSearchDispatchListStart(
  state: ZeroVendorState,
  action: SearchZeroVendorListStartAction
): ZeroVendorState {
  return {
    ...state,
    query: action.query,
    loading: true
  };
}

function handleSearchDispatchListSuccess(
  state: ZeroVendorState,
  action: SearchZeroVendorListSuccessAction
): ZeroVendorState {
  return {
    ...state,
    pageNumber: action.pageNumber,
    pageSize: action.result.pageSize,
    pageCount: Math.ceil(action.result.totalResults / action.result.pageSize),
    swoList: action.result.results,
    orderBy: action.orderBy,
    loading: false
  };
}
function handleSearchDispatchListFailure(
  state: ZeroVendorState,
  action: SearchZeroVendorListFailureAction
): ZeroVendorState {
  return {
    ...state,
    message: action.error,
    loading: false
  };
}

export const ZeroVendorReducer = createReducer<ZeroVendorState, ZeroVendorActionType>(initialZeroVendorState, {
  [ZeroVendorActionType.SearchZeroVendorListStart]: handleSearchDispatchListStart,
  [ZeroVendorActionType.SearchZeroVendorListSuccess]: handleSearchDispatchListSuccess,
  [ZeroVendorActionType.SearchZeroVendorListFailure]: handleSearchDispatchListFailure
});



// WEBPACK FOOTER //
// ./src/service-work-order/zero-vendor/zero-vendor.reducer.tsx